module.exports = __webpack_public_path__ + "img/error.35979c25.svg";